import { flowActionCreator } from 'utils/actionUtils';
import Constants from './constants';

const ACTION_PREFIX = Constants.MODULE_NAME;

const currentUserActionFlow = flowActionCreator(ACTION_PREFIX, 'CURRENT_USER');

export const UserActionTypes = {
  CURRENT_USER: currentUserActionFlow[0],
  CLOSED_PASSWORD_BANNER: `${ACTION_PREFIX}/CLOSED_PASSWORD_BANNER`,
};

export function closedPasswordBanner() {
  return { type: UserActionTypes.CLOSED_PASSWORD_BANNER };
}

export const UserActions = {
  currentUser: currentUserActionFlow[1],
  closedPasswordBanner,
};
